module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-dvd-2c73b21c1d88a6c231fdffef8a040daf.svg";